const STORAGE_KEYS = {
  // Auth & Session
  UDID: "udid",
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER_ID: "user_id",
  TEMP_ACCESS_TOKEN: "temp_access_token",
  TEMP_REFRESH_TOKEN: "temp_refresh_token",
  
  // User Profile
  EMAIL: "email",
  FULL_NAME: "fullName",
  IS_EMAIL_VERIFIED: "isEmailVerified",
  ACCOUNT_ID: "accountId",
  PHONE_NUMBER: "phoneNumber",

  // Feature Flags & Status
  IS_NUMBER_REG: "isNumberRegistered",
  IS_NUMBER_PURCHASED: "isNumberPurchased",
  IS_SUPPORT_AGENT: "isSupportAgent",
  ALREADY_OPENED_E911_ONCE: "alreadyOpenedE911Once",

  // App Preferences & State
  THEME: "theme",
  DTMF_MODE: "dtmfMode",
  FORWARDED_MESSAGE_IDS: "forwardedMsgIds",
} as const;

export default STORAGE_KEYS;
export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];
